export default __webpack_public_path__ + "static/media/gerry.48777032.jpg";